import react from 'react';
import '../scss/AboutMe.scss';

function About(){
    return (
        <div className="aboutMe">
            <div>
                <hr/>
                <h2>When I picked up my first camera, I knew I was in it for the long-run. Pictures help us remember the most significant parts of our lives. They can make us smile. They can make us cry. They can make us realize how beautiful we truly are. It's my job to capture the moments in life when we wish we could freeze time.</h2>
                <hr/>
            </div>
        </div>
    )
}

export default About;